import { createContext } from 'react';

export interface CartVendorType {
  id: string;
  name: string;
}

export interface CombinationType {
  option: {
    id: string;
    name: string;
    price: number;
    isVegetarian: boolean;
  };
  addOns?: {
    id: string;
    name: string;
    price: number;
    isVegetarian: boolean;
  }[];
}

export interface CartDishType {
  id: string;
  quantity: number;
  category: {
    name: string;
  };
  name: string;
  price: number;
  isVegetarian: boolean;
  options?: {
    id: string;
    name: string;
    price: number;
    isVegetarian: boolean;
  }[];
  addOns?: {
    id: string;
    name: string;
    price: number;
    isVegetarian: boolean;
  }[];
  combinations?: CombinationType[];
  notes: string;
  scheduledTime: string;
}

export interface CartContextState {
  vendorOnCart: CartVendorType;
  dishesOnCart: CartDishType[];
  notes: string;
  scheduledTime: string;
}

export interface CartContextData {
  cartState: CartContextState;
  cartDispatch: ({ type, payload }: { type: string; payload: any }) => void;
}

const CartContext = createContext({} as CartContextData);

export default CartContext;

// export { CartContextData, CartContextState };
